export const userInfo = state => state.userInfo

export const userId = state => state.userId

export const openId = state => state.openId

export const loginStatus = state => state.loginStatus

export const token = state => state.token

export const showLeftStatus = state => state.showLeftStatus



// WEBPACK FOOTER //
// ./src/store/getters.js